// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"3db0ffa1","787":"09c4dc52","975":"b9aea53b"}[chunkId] + ".chunk.js";
};